const rawBlockTypes = ['section', 'text'];
const rowBreakBlockTypes = ['section'];

export { rowBreakBlockTypes, rawBlockTypes };
